import { GeotabSensor } from "../../../../../../models";
import { EditSensorActions, EditSensorStoreState } from "../../flux";
import { Command1 } from "../../../../../../Command";

export class SetGeotabSensorCommand implements Command1<GeotabSensor>
{
    private readonly editActions = new EditSensorActions();
    constructor(private getState: () => EditSensorStoreState)
    {
    }
    
    execute = (geotabSensor: GeotabSensor): void => {
        this.editActions.setGeotabSensor(geotabSensor);
        if(geotabSensor == null) {
            this.editActions.setQuantity(null, null);
        } else {
            const { quantities } = this.getState();
            
            const quantity = quantities.find(item => item.Id === geotabSensor.QuantityId);
            const uId = quantity ? quantity.Units[0] : null;
            
            this.editActions.setQuantity(geotabSensor.QuantityId, uId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/Sensor/SetGeotabSensorCommand.ts